<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: amtlicheBewertung }"></ng-template>

<ng-template #typ00 let-amtlicheBewertung>
  <ng-container>{{ "AW" | translate }}: {{ amtlicheBewertung.amtlicherWert | betrag }}</ng-container>
  @if (amtlicheBewertung.mitEwKomponente) {
    {{ "(mit Ertragswertkomponente)" | translate }}
  }
  @if (amtlicheBewertung.ertragsWert) {
    , {{ "EW" | translate }}: {{ amtlicheBewertung.ertragsWert | betrag }}
  }
  @if (amtlicheBewertung.protokollNummer) {
    , {{ "Protokollnummer" | translate }}: {{ amtlicheBewertung.protokollNummer }}
  }
  @if (amtlicheBewertung.protokollDatum) {
    , {{ "vom" | translate }} : {{ amtlicheBewertung.protokollDatum | datum }}
  }
  @if (amtlicheBewertung.protokollGueltig != null && amtlicheBewertung.aktualisierungsdatum === null) {
    , {{ "Gültig" | translate }}:
    @if (amtlicheBewertung.protokollGueltig) {
      <span> {{ "Ja" | translate }}</span>
    }
    @if (!amtlicheBewertung.protokollGueltig) {
      <span> {{ "Nein" | translate }}</span>
    }
  }
  @if (amtlicheBewertung.gueltigAbSteuerjahr) {
    , {{ "gültigAbSteuerjahr" | translate }}: {{ amtlicheBewertung.gueltigAbSteuerjahr }}
  }
  @if (amtlicheBewertung.aktualisierungsdatum) {
    , {{ "aktualisierungsdatum" | translate }} {{ amtlicheBewertung.aktualisierungsdatum | datumZeit }}
  }
</ng-template>

<ng-template #typ01 let-amtlicheBewertung>
  <ng-container>{{ "AW" | translate }}: {{ amtlicheBewertung.amtlicherWert | betrag }}</ng-container>
  @if (amtlicheBewertung.mitEwKomponente) {
    {{ "(mit Ertragswertkomponente)" | translate }}
  }
  @if (amtlicheBewertung.protokollNummer) {
    , {{ "Protokollnummer" | translate }}: {{ amtlicheBewertung.protokollNummer }}
  }
  @if (amtlicheBewertung.protokollDatum) {
    , {{ "vom" | translate }} : {{ amtlicheBewertung.protokollDatum | datum }}
  }
  @if (amtlicheBewertung.protokollGueltig != null) {
    , {{ "Gültig" | translate }}:
    @if (amtlicheBewertung.protokollGueltig) {
      <span>
        {{ "Ja" | translate }}
      </span>
    }
    @if (!amtlicheBewertung.protokollGueltig) {
      <span>
        {{ "Nein" | translate }}
      </span>
    }
  }
</ng-template>

<ng-template #typ02 let-amtlicheBewertung>
  <ng-container>{{ "AW: " | translate }} {{ amtlicheBewertung.amtlicherWert | betrag }}</ng-container>
  @if (amtlicheBewertung.gueltigAbSteuerjahr) {
    , {{ "gültigAbSteuerjahr" | translate }}: {{ amtlicheBewertung.gueltigAbSteuerjahr }}
  }
</ng-template>

<ng-template #typ03 let-amtlicheBewertung>
  <ng-container>{{ "Gebaeudeschatzung" | translate }}: {{ amtlicheBewertung.taxeBatiment | betrag }}</ng-container>
  @if (amtlicheBewertung.taxeNature) {
    , {{ "Grundgueterschaetzung" | translate }}:
    {{ amtlicheBewertung.taxeNature | betrag }}
  }
  @if (amtlicheBewertung.amtlicherWert) {
    {{ "AW" | translate }}: {{ amtlicheBewertung.amtlicherWert | betrag }}
  }
  @if (amtlicheBewertung.protokollGueltig != null) {
    , {{ "Gültig" | translate }}: {{ amtlicheBewertung.protokollGueltig | translate }}
    @if (amtlicheBewertung.protokollGueltig) {
      <span>
        {{ "Ja" | translate }}
      </span>
    }
    @if (!amtlicheBewertung.protokollGueltig) {
      <span>
        {{ "Nein" | translate }}
      </span>
    }
  }
</ng-template>
